<template>
    <modal-dialog
        ref="modalDialog"
        confirmBtnTxt="Save"
        :isLoading="isLoading.submit"
        @confirm-dialog="save"
        @close="clear"
    >
        <template v-slot:title>
            Select Bundle
        </template>
        <template v-slot:body>
            <div>
                <div class="container-fluid">
                    <div class="alert alert-warning" role="alert">
                        Select the bundle(s) you want to include below. Only
                        bundles that don't have other bundles in them can be
                        included.
                    </div>

                    <div class="form-group form-row">
                        <label for="templates" class="col-md-3 col-form-label">
                            Bundle(s):
                        </label>
                        <div class="col-md-9">
                            <v-select
                                ref="bundleSelect"
                                id="templates"
                                name="templates"
                                v-validate="'required'"
                                :options="filteredBundleOptions"
                                :disabled="isLoading.bundle"
                                :placeholder="
                                    isLoading.bundle ? 'Loading...' : ''
                                "
                                @search:blur="clearSearch"
                                v-model="templates"
                                :class="{
                                    'border-danger': errors.has('templates')
                                }"
                                multiple
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal-dialog>
</template>

<script>
import { map, differenceBy, sortBy } from "lodash";
import TemplateService from "@/services/templates";

export default {
    components: {
        ModalDialog: () => import("@/components/commons/modal-dialog.vue"),
        vSelect: () => import("vue-select")
    },
    props: {
        templateId: {
            type: String,
            required: true
        }
    },
    computed: {
        bundleOptions() {
            return map(this.bundles, (label, value) => ({ value, label }));
        },
        filteredBundleOptions() {
            return differenceBy(this.bundleOptions, this.templates, "value");
        }
    },
    watch: {},
    data() {
        return {
            isLoading: {
                submit: false,
                bundle: false
            },
            bundles: [],
            templates: []
        };
    },
    mounted() {},
    destroyed() {},
    methods: {
        open() {
            this.getBundles();
            this.$refs.modalDialog.open();
        },
        async getBundles() {
            try {
                this.isLoading.bundle = true;

                const response = await TemplateService.getBundleList(
                    this.templateId
                );

                if (response && response.code === 200) {
                    this.bundles = response.resources;
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.log(error);
                this._message(error.message, "danger");
            } finally {
                this.isLoading.bundle = false;
            }
        },
        async save() {
            let valid = await this.$validator.validateAll();

            if (!valid) {
                return false;
            }

            try {
                this.isLoading.submit = true;

                const sortedTemplates = sortBy(
                    this.templates,
                    template => template.label
                );

                const response = await TemplateService.addBundle(
                    this.templateId,
                    {
                        template: sortedTemplates.map(
                            template => template.value
                        )
                    }
                );

                if (response && response.code === 200) {
                    this._message(response.message, "success");
                    this.$emit("onsuccess");
                    this.$refs.modalDialog.close();
                    this.clear();
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                this._message(error.message, "danger");
            } finally {
                this.isLoading.submit = false;
            }
        },
        clearSearch() {
            this.$refs.bundleSelect.search = "";
        },
        clear() {
            this.templates = [];
            this.$validator.reset();
        }
    }
};
</script>
